import moment from 'moment';
import format from 'date-fns/format';
import { QuestionTextField, QuestionDropDownField, QuestionJurisdictionDropDownField, QuestionDateDropdownField } from 'components/Questionnaires/fields';
import { QuestionAddressBlock, QuestionTaxResidenceBlock, QuestionBlockRepeater, QuestionSignerBlock } from 'components/Questionnaires/blocks';
import { requiredValidator } from 'components/Questionnaires/validators';

const crsI = {
  blocks: [
    {
      id: 'name',
      title: 'questionnaire.crs.name',
      component: undefined, // Component for Block
      info: {
        instructions: 'questionnaire.crs.name.firstName.info'
      },
      visible: true,
      questions: [
        {
          id: 'title',
          label: 'questionnaire.crs.name.title.label',
          component: QuestionDropDownField,
          componentProps: {
            items: 'questionnaire.crs.name.titles'
          },
          className: 'col-12 col-lg-3',
          visible: true,
          lockGroup: 'name',
        },
        {
          id: 'titleOther',
          label: 'questionnaire.crs.name.titleOther.label',
          component: QuestionTextField,
          className: 'col-12 col-lg-9',
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.title === 'Other',
          lockGroup: 'name',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.name.titleOther.errorMessage' }
            ]
          }
        },
        {
          id: 'firstName',
          label: 'questionnaire.crs.name.firstName.label',
          component: QuestionTextField,
          className: 'col-12 col-lg-9',
          visible: true,
          lockGroup: 'name',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.name.firstName.errorMessage' }
            ]
          }
        },
        {
          id: 'middleName',
          label: 'questionnaire.crs.name.middleName.label',
          component: QuestionTextField,
          className: 'col-12 col-lg-4',
          visible: true,
          lockGroup: 'name',
        },
        {
          id: 'lastName',
          label: 'questionnaire.crs.name.lastName.label',
          component: QuestionTextField,
          className: 'col-12 col-lg-8',
          visible: true,
          lockGroup: 'name',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.name.lastName.errorMessage' }
            ]
          }
        },
      ]
    },
    {
      id: 'address',
      title: 'questionnaire.address',
      component: QuestionAddressBlock,
      info: {
        instructions: 'questionnaire.address.1.info'
      },
      visible: true,
      lockGroup: 'permanentAddress',
    },
    {
      id: 'mailingAddress',
      title: 'questionnaire.mailingAddress',
      component: QuestionAddressBlock,
      componentProps: {
        line1Label: 'questionnaire.mailingAddress.1.label',
        optional: true
      },
      info: {
        instructions: 'questionnaire.mailingAddress.1.info'
      },
      visible: true,
      linkBlock: true,
      lockGroup: 'mailingAddress',
    },
    {
      id: 'taxResidences',
      title: 'questionnaire.taxResidences',
      component: QuestionBlockRepeater,
      componentProps: {
        collapsible: true
      },
      repeatBlock: {
        id: 'taxResidence',
        title: 'questionnaire.taxResidence.additional',
        component: QuestionTaxResidenceBlock,
        componentProps: {
          optional: true
        }
      },
      minSize: 1,
      maxSize: 5,
      addText: 'questionnaire.taxResidences.addLabel',
      visible: true,
    },
    {
      id: 'birth',
      title: 'questionnaire.birth',
      component: undefined, // Component for Block
      visible: true,
      questions: [
        {
          id: 'date',
          label: 'questionnaire.birth.date.label',
          component: QuestionDateDropdownField,
          componentProps: {
            minDate: format(moment().subtract(125, 'years').toDate(), 'dd-MM-yyyy'),
            maxDate: format(moment().subtract(1, 'days').toDate(), 'dd-MM-yyyy'),
            dateFormat: 'dd-MM-yyyy',
            showToolTip: true
          },
          info: {
            instructions: 'questionnaire.birth.date.info'
          },
          className: 'col-12',
          visible: true,
          lockGroup: 'dateOfBirth',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.birth.date.errorMessage' }
            ]
          }
        },
        {
          id: 'town',
          label: 'questionnaire.birth.town.label',
          component: QuestionTextField,
          className: 'col-12 col-lg-5',
          visible: true,
          lockGroup: 'cityOfBirth',
        },
        {
          id: 'country',
          label: 'questionnaire.birth.country.label',
          component: QuestionJurisdictionDropDownField,
          className: 'col-12 col-lg-7',
          visible: true,
          lockGroup: 'countryOfBirth'
        },
      ]
    },
    {
      id: 'signer',
      title: 'questionnaire.signer',
      component: QuestionSignerBlock,
      componentProps: {
        individualOnly: true
      },
      visible: true
    },
  ]
};

export default crsI;
